import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { FullPageLoader } from "@/components/FullPageLoader";
import { safeNext } from "@/lib/navigation";
import { ROUTES } from "@/constants/routes";

export function PublicOnlyRoute() {
  const { session, loading } = useAuth();
  const location = useLocation();
  if (loading) return <FullPageLoader label="Checking your session" />;
  if (session) return <Navigate to={safeNext(location.search) || ROUTES.dashboard} replace />;
  return <Outlet />;
}
